import type { Offer } from '@/types';

export function setOffer(offer?: Offer) {
  function setPriceSpecification(
    priceSpecification: Offer['priceSpecification'],
  ) {
    if (priceSpecification) {
      return {
        '@type': priceSpecification.type,
        price: priceSpecification.price,
        priceCurrency: priceSpecification.priceCurrency,
      };
    }

    return undefined;
  }

  function setItemOffered(itemOffered: Offer['itemOffered']) {
    if (itemOffered) {
      return {
        ...itemOffered,
        '@type': 'Service',
      };
    }

    return undefined;
  }

  if (offer) {
    return {
      ...offer,
      '@type': 'Offer',
      itemOffered: setItemOffered(offer.itemOffered),
      priceSpecification: setPriceSpecification(offer.priceSpecification),
    };
  }

  return undefined;
}
